<ng-container
  *ngLet="
    settingsService.screenBreakpoint$
      | async
      | appScreenLessThan: BreakpointTypeEnum.HalfSmall as mobile
  "
>
  <div
    class="--flex --col --align-center --gap-24 app-bg-main w-100 app-border-radius-12 pdng-16 app-shadow"
    [ngClass]="mobile ? 'w-100 mrgn-top-100' : 'w-600-px mrgn-top-200'"
  >
    <app-svg type="none" class="w-100" src="/assets/img/404.svg"></app-svg>

    <span class="heading-primary-bold-20 app-text-color-50"> Страница не найдена </span>

    <app-button type="danger" class="w-100" (click)="toMain()"> На главную </app-button>
  </div>
</ng-container>
